<div class="card mb-0">
    <h5 class="card-header">
        Group Invoices
    </h5>
    <div class="card-body">
        <div class="row justify-content-start p-0">
            <div class="col-12 col-sm-6">
                <div class="input-group mb-3 zindex-1 form-group">
                    <input class="form-control mt-0 mb-0" type="text" style="padding:8px;margin:15px auto;width:30%;"
                        placeholder="Search..." (keyup)="updateFilter($event)" />
        
                    <button class="btn btn-outline-secondary" type="button" id="button-addon2">
                        <i class="fa fa-search"></i>
                    </button>
                </div>
            </div>
        </div>
        <div class="technical-datatable responsive-datatable">
            <ngx-datatable class="material" [rows]="rows" [count]="totalRecords" [limit]="pageSize" [rowHeight]="'auto'"
                [headerHeight]="45" [footerHeight]="45" [externalPaging]="true" [externalSorting]="true"
                (sort)="onSort($event)" (page)="onPage($event)" [rowClass]="getRowClass" (activate)="onRowActivate($event)">

                <ngx-datatable-column name="Action" [width]="50" [sortable]="false">
                    <ng-template ngx-datatable-header-template>
                        <input type="checkbox" [(ngModel)]="isAllSelected" (change)="toggleAll()">
                    </ng-template>

                    <ng-template ngx-datatable-cell-template let-row="row">
                        <input type="checkbox" [(ngModel)]="row.isSelected" (click)="$event.stopPropagation()" (change)="onCheckboxChange()">
                    </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column name="Client Name" prop="ClientName" [width]="250">
                    <ng-template ngx-datatable-cell-template let-row="row">
                        {{ row.ClientName }}
                    </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column name="Case Number" prop="CaseNumber" [width]="200">
                    <ng-template ngx-datatable-cell-template let-row="row">
                        {{ row.CaseNumber }}
                    </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column name="Invoice Type" prop="InvoiceType">
                    <ng-template ngx-datatable-cell-template let-row="row">
                        {{ row.InvoiceType }}
                    </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column name="Invoice Number" prop="InvoiceNumber" [width]="250">
                    <ng-template ngx-datatable-cell-template let-row="row">
                        {{ row.InvoiceNumber }}
                    </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column name="Invoice Date" prop="InvoiceDate">
                    <ng-template ngx-datatable-cell-template let-row="row">
                        {{ row.InvoiceDate }}
                    </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column name="Received Date" prop="ReceivedDate">
                    <ng-template ngx-datatable-cell-template let-row="row">
                        {{ row.ReceivedDate }}
                    </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column name="Currency" prop="Currency">
                    <ng-template ngx-datatable-cell-template let-row="row">
                        {{ row.Currency }}
                    </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column name="Ex Vat" class="valuesRight" prop="InvoiceExVat">
                    <ng-template ngx-datatable-cell-template let-row="row">
                        {{ row.InvoiceExVat | number : '1.2-2' }}
                    </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column name="VAT" class="valuesRight" prop="InvoiceVat">
                    <ng-template ngx-datatable-cell-template let-row="row">
                        {{ row.InvoiceVat | number : '1.2-2' }}
                    </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column name="Total" class="valuesRight" prop="InvoiceTotal">
                    <ng-template ngx-datatable-cell-template let-row="row">
                        {{ row.InvoiceTotal | number : '1.2-2' }}
                    </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column name="Responsible" prop="Responsible">
                    <ng-template ngx-datatable-cell-template let-row="row">
                        {{ row.Responsible }}
                    </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-footer>
                    <ng-template ngx-datatable-footer-template let-rowCount="rowCount" let-pageSize="pageSize"
                        let-curPage="curPage" let-totalPages="totalPages">

                        <div class="d-flex justify-content-between align-items-center w-100">

                            <div>
                                <strong>{{ globalSelectedCount }} selected / {{ rowCount }} total</strong>
                            </div>

                            <div>
                                <app-datatable-pager [page]="curPage" [size]="pageSize" [count]="rowCount"
                                    [visiblePagesCount]="totalPages" (change)="onPage($event)">
                                </app-datatable-pager>
                            </div>

                            <div>

                            </div>

                        </div>

                    </ng-template>
                </ngx-datatable-footer>
            </ngx-datatable>
        </div>
    </div>

    <footer class="card-footer text-right d-flex justify-content-between">
        <div>

        </div>
        <div class="d-flex flex-wrap align-items-center gap-2">
            <button type="button" (click)="select()" [disabled]="selectedRows.length === 0"
                class="btn btn-primary">Add Invoices</button>
            <button type="button" class="btn btn-dark ms-2" (click)="close()">Close</button>
        </div>
    </footer>
</div>